
import { FaServer, FaTools } from "react-icons/fa";
import {
  SiReact,
  SiJavascript,
  SiHtml5,
  SiRedux,
  SiNodedotjs,
  SiGit,
  SiJira,
  SiFigma,
} from "react-icons/si";

const skillsData = [
  {
    label: "Frontend",
    icon: <SiReact />,
    progress: "92%",
    items: [
      { name: "ReactJS", icon: <SiReact /> },
      { name: "JavaScript", icon: <SiJavascript /> },
      { name: "HTML5", icon: <SiHtml5 /> },
      { name: "CSS3", icon: <FaTools /> },
      { name: "Redux", icon: <SiRedux /> },
    ],
  },
  {
    label: "Backend",
    icon: <FaServer />,
    progress: "80%",
    items: [
      { name: "NodeJS", icon: <SiNodedotjs /> },
      { name: "REST API", icon: <FaServer /> },
    ],
  },
  {
    label: "Tools & Collaboration",
    icon: <FaTools />,
    progress: "86%",
    items: [
      { name: "Git", icon: <SiGit /> },
      { name: "JIRA", icon: <SiJira /> },
      { name: "Figma", icon: <SiFigma /> },
      { name: "Debugging", icon: <FaTools /> },
    ],
  },
];

export default function Skills() {
  return (
    <>
      <div className="section-header">
        <p className="section-kicker">Skills</p>
        <h2 className="section-title">Technologies I work with</h2>
        <p className="section-description">
          A focused stack built around React and modern JavaScript, backed by solid tooling for
          building, debugging, and shipping reliable experiences.
        </p>
      </div>

      <div className="skills-grid grid grid-3">
        {skillsData.map((group) => (
          <article key={group.label} className="card">
            <div className="card-header">
              <div className="card-icon">{group.icon}</div>
              <div>
                <div className="card-title">{group.label}</div>
                <div className="card-subtitle">Hands-on, production usage</div>
              </div>
            </div>

            <div className="card-body">
              <div className="skill-category">Core tools</div>
              <div className="skill-list">
                {group.items.map((item) => (
                  <span key={item.name} className="skill-badge">
                    <span>{item.icon}</span>
                    <span>{item.name}</span>
                  </span>
                ))}
              </div>

              <div
                className="skill-progress-track"
                style={{ "--progress": group.progress }}
              >
                <div className="skill-progress-bar" />
              </div>
            </div>
          </article>
        ))}
      </div>
    </>
  );
}
